import { provideBrowserGlobalErrorListeners } from '@angular/core';
// Import AG Grid Enterprise packages first
import 'ag-grid-enterprise';

// Register all required AG Grid Enterprise modules
import { LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import { AllEnterpriseModule } from 'ag-grid-enterprise';

ModuleRegistry.registerModules([
  AllEnterpriseModule
]);

// Initialize Sentry
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment';
import { BUILD_VERSION } from './environments/build-version';

// Before any grid is created. A build without the key (local, tests) keeps
// the evaluation watermark rather than failing the boot.
const agGridLicenseKey =
  typeof AG_GRID_LICENSE_KEY === 'string' ? AG_GRID_LICENSE_KEY : '';
if (agGridLicenseKey) {
  LicenseManager.setLicenseKey(agGridLicenseKey);
}

if (environment.sentry?.enabled) {
  const sentryConf = environment.sentry;

  Sentry.init({
    dsn: sentryConf.dsn,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: sentryConf.sendDefaultPii,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: true,
      }),
    ],
    environment: sentryConf.environment,
    // The deployed commit, so an event says which build raised it.
    release: BUILD_VERSION ?? undefined,
    // Tracing
    tracesSampleRate: sentryConf.tracesSampleRate,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/[\w.-]+\.domaingrc\.com\/api/],
    // Session Replay
    replaysSessionSampleRate: sentryConf.replaysSessionSampleRate, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: sentryConf.replaysOnErrorSampleRate // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { redirectOpenLink } from './app/open-link';

// Open links (`/open/…`, from emails) are path-based so phones can claim them
// as Universal Links / App Links; the hash router would ignore the path and
// land on the homepage. Decide where this browser goes before booting, and
// skip the boot when it is leaving.
const redirecting = redirectOpenLink(
  window.location,
  window.navigator,
  environment.mobileStores ?? null
);

if (!redirecting) {
  bootstrapApplication(AppComponent, {...appConfig, providers: [provideBrowserGlobalErrorListeners(), ...appConfig.providers]}).catch((err) =>
    console.error(err)
  );
}
